import { Box, Typography, useTheme } from "@mui/material";
import { DashboardIcon } from "./DashboardBuilder";

export default function DashboardHeroCardPercentage({
  header,
  label,
  footerLabel,
  value,
  icon,
  color
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const Icon = icon ? DashboardIcon(icon) : null;

  return (
    <Box
      sx={{
        textAlign: "center",
        p: { xs: 1.5, sm: 2 },
        borderRadius: 1,
        border: `1px solid ${color}33`,
        backgroundColor: isDark ? `${color}12` : `${color}0a`,
        height: "100%",
        containerType: "inline-size"
      }}
    >
      {header?.length > 0 && (
        <Typography
          sx={{
            color: theme.palette.text.primary,
            fontSize: "0.7rem",
            textTransform: "uppercase",
            letterSpacing: "0.12em",
            fontWeight: 600,
            mb: 1.25
          }}
        >
          {header}
        </Typography>
      )}

      {Icon && (
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1.25 }}>
          <Icon size="lg" style={{ color }} />
        </Box>
      )}

      {value !== undefined && (
        <Typography
          sx={{
            color,
            fontWeight: 700,
            fontSize: "2.25rem",
            lineHeight: 1,
            mb: 0.5,
            fontVariantNumeric: "tabular-nums",
            whiteSpace: "nowrap"
          }}
        >
          {value}%
        </Typography>
      )}

      {label?.length > 0 && (
        <Typography
          sx={{
            color: theme.palette.text.secondary,
            fontSize: "0.65rem",
            textTransform: "uppercase",
            letterSpacing: "0.1em",
            fontWeight: 600,
            mb: 1.75
          }}
        >
          {label}
        </Typography>
      )}

      {value !== undefined && (
        <Box
          sx={{
            height: 6,
            borderRadius: 3,
            backgroundColor: isDark
              ? "rgba(255,255,255,0.08)"
              : "rgba(0,0,0,0.08)",
            overflow: "hidden",
            mb: 1.75
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: `${value}%`,
              borderRadius: 3,
              background: `linear-gradient(90deg, ${color}55, ${color})`
            }}
          />
        </Box>
      )}

      {footerLabel?.length > 0 && (
        <Typography
          sx={{
            color: theme.palette.text.secondary,
            fontSize: "0.8rem",
            fontVariantNumeric: "tabular-nums"
          }}
        >
          {footerLabel}
        </Typography>
      )}
    </Box>
  );
}
